import http from '@http';

export const getHomePageData = async () => {
  const { data } = await http.get(`/home`);
  return data;
};

export const getPromoSliderData = async () => {
  const { data } = await http.get(`/top-banners`);
  return data;
};

export const getHomePageCustomRows = async () => {
  const { data } = await http.get(`/home/custom`);
  return data;
};
